<template>
  <v-container class="pa-5">
    <!-- padding around the container (outside the card) -->
    <v-card class="pa-5">
      <!-- padding inside the card -->

      <!-- Title -->
      <v-row>
        <v-col>
          <h3 class="primary--text text-center">About Us</h3>
        </v-col>
      </v-row>

      <!-- Content -->
      <v-row>
        <!-- Pictures on the left -->
        <v-col cols="12" md="6">
          <v-row no-gutters>
            <v-col cols="7">
              <v-img
                src="@/assets/images/about-us/love-paws-homestay-omana.jpg"
                @click.stop="showPopup('Love Paws Homestay','omana')"
              ></v-img>
              <v-img
                src="@/assets/images/about-us/love-paws-homestay-dogs.jpg"
                @click.stop="showPopup('Pet Boarding','dogs')"
              ></v-img>
            </v-col>
            <v-col cols="5">
              <v-img
                src="@/assets/images/about-us/love-paws-homestay-grooming.jpg"
                @click.stop="showPopup('Pet Grooming','grooming')"
              ></v-img>
              <v-img
                src="@/assets/images/about-us/love-paws-homestay-swimming.jpg"
                @click.stop="showPopup('Pet Swimming','swimming')"
              ></v-img>
            </v-col>
          </v-row>
        </v-col>

        <!-- About us text on the right -->
        <v-col>
          <p>My name is Omana and I run Love Paws Homestay with my family in our 6,000 sqft home.</p>
          <p>The environment is a spacious garden, a hilltop view, and an interior that will be a vacation for your pets. Your furkins will enjoy the sense of freedom to roam around the wide outdoor and indoor area.</p>
          <p>I am also a trained pet groomer providing both basic and full grooming services to make your pets look pretty.</p>
          <p>I have dogs and cats of my own and I know how it feels to leave them home during long working hours or when going on holidays. I assure that your furkins will feel safe and happy at Love Paws Homestay.</p>
          <p>
            I also manage my
            <a
              href="https://www.facebook.com/groups/1045919972092486/"
              target="_blank"
            >Dog Lovers in Malaysia</a> Facebook page, which has over 6,000 members to help spread awareness on behalf of all dog lovers and rescuers for animals in Malaysia.
          </p>
          <p>
            Make a booking for your pet grooming and boarding needs, or click the
            <a
              href="https://api.whatsapp.com/send?phone=60173797632"
              target="_blank"
            >WhatsApp</a> icon to get in touch.
          </p>
          <p>
            <v-btn outlined color="primary" @click="makeABooking">Make A Booking</v-btn>
          </p>
        </v-col>
      </v-row>
    </v-card>

    <!-- Popup dialog when a picture is clicked -->
    <v-dialog v-model="showDialog" :width="$vuetify.breakpoint.thresholds.sm" height="auto">
      <v-card>
        <v-card-title class="headline primary mb-4">
          <span class="mx-auto white--text">{{ dialogTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-img :src="dialogImage"></v-img>
        </v-card-text>
        <v-card-actions>
          <v-btn class="primary mx-4 flex-grow-1" x-large @click="showDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    showDialog: false,
    dialogTitle: "",
    dialogImage: ""
  }),
  methods: {
    showPopup: function(title, imageName) {
      this.dialogTitle = title;
      this.dialogImage = require(`@/assets/images/about-us/love-paws-homestay-${imageName}.jpg`);
      this.showDialog = true;
    },
    makeABooking: function() {
      const bookingDate = new Date().toISOString().substr(0, 10);
      this.$emit("book", bookingDate);
    }
  }
};
</script>